import { render } from "./LastNMatchesStat.vue?vue&type=template&id=6b66e036&scoped=true"
import script from "./LastNMatchesStat.vue?vue&type=script&lang=js"
export * from "./LastNMatchesStat.vue?vue&type=script&lang=js"

import "./LastNMatchesStat.vue?vue&type=style&index=0&id=6b66e036&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b66e036"]])

export default __exports__